document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-pm-slideshow]').forEach(function (root) {
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-pm-slide]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-pm-dot]'));
    var prevBtn = root.querySelector('[data-pm-prev]');
    var nextBtn = root.querySelector('[data-pm-next]');
    var autoplay = root.getAttribute('data-autoplay') === 'true';
    var speed = parseInt(root.getAttribute('data-speed'), 10) || 5000;
    var current = 0;
    var timer = null;

    if (slides.length < 2) return;

    function show(index) {
      slides[current].classList.remove('pm-slide--active');
      if (dots[current]) dots[current].classList.remove('pm-dot--active');
      current = (index + slides.length) % slides.length;
      slides[current].classList.add('pm-slide--active');
      if (dots[current]) dots[current].classList.add('pm-dot--active');
    }

    function next() { show(current + 1); }
    function prev() { show(current - 1); }

    function startAutoplay() {
      if (!autoplay) return;
      stopAutoplay();
      timer = setInterval(next, speed);
    }

    function stopAutoplay() {
      if (timer) clearInterval(timer);
    }

    if (nextBtn) nextBtn.addEventListener('click', function () { next(); startAutoplay(); });
    if (prevBtn) prevBtn.addEventListener('click', function () { prev(); startAutoplay(); });

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        show(parseInt(dot.getAttribute('data-index'), 10));
        startAutoplay();
      });
    });

    root.addEventListener('mouseenter', stopAutoplay);
    root.addEventListener('mouseleave', startAutoplay);

    startAutoplay();
  });
});
